import { gql } from '@apollo/client';

const CREATE_UPDATE_INCOMINGORDERS_GROUP = gql`mutation createUpdateIncomingOrdersGroup($input: IncomingOrdersGroupInput)
{
	incomingOrders{
		createUpdateGroup(input: $input){
			success
			result{
				id
				name
			}
			errorResult{
				errorCode
				errorMessage
				data{
					key
					value
				}
			}
		}
	}
}`;

export default CREATE_UPDATE_INCOMINGORDERS_GROUP;